<div class="specs">
  <form [formGroup]="basicAreaPropertiesForm" fxLayout="row">

    <!-- Area location -->
    <div class="location" fxFlex="70">
      <div fxFlex>
        <div class="title">
          Ruimtetype
        </div>
        <mat-form-field>
          <mat-select formControlName="areaType">
            <mat-option *ngFor="let areaType of [this.basicArea.templateId.name]" [value]="areaType">
              {{ areaType }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex>
        <div class="title">
          Kwaliteitsniveau
        </div>
        <mat-form-field>
          <mat-select formControlName="qualityLevel">
            <mat-option *ngFor="let qualityLevel of qualityLevels" [value]="qualityLevel.value">
              {{ qualityLevel.displayName }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
      <div fxFlex>
        <div class="title">
          Bron
        </div>
        <mat-form-field>
          <mat-select formControlName="source">
            {{ source }}
            <mat-option *ngFor="let src of [source]" [value]="src">
              {{ src }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

    <!-- Area properties -->
    <div class="properties" fxFlex="30" fxLayout="row">
      <div fxFlex>
        <div class="title">
          Gekoppelde ruimten
        </div>
        <mat-form-field>
          <mat-select formControlName="areas">
            <mat-option value="numberOfAreas">
              {{ areas.length }} 
              {{ 'area' | translate: (areas.length === 1 ? 'lowerCase' : 'pluralLowerCase') }}
            </mat-option>
            <mat-divider></mat-divider>
            <mat-option *ngFor="let area of areas" [value]="area.name" (click)="goToArea($event, area)">
              {{ area.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>
    </div>

  </form>
</div>
